/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Control_Browse_PuzzlesInputs */

const en_control_browse_puzzles = /** @type {(inputs: Control_Browse_PuzzlesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Browse Puzzle Solutions`)
};

const zh_control_browse_puzzles = /** @type {(inputs: Control_Browse_PuzzlesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`查看谜题答案`)
};

/**
* | output |
* | --- |
* | "Browse Puzzle Solutions" |
*
* @param {Control_Browse_PuzzlesInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const control_browse_puzzles = /** @type {((inputs?: Control_Browse_PuzzlesInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Control_Browse_PuzzlesInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_control_browse_puzzles(inputs)
	return zh_control_browse_puzzles(inputs)
});
export { control_browse_puzzles as "control.browse_puzzles" }